export default {"src":"/_next/static/media/passport-bg.13b0e64b.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};